import { render, staticRenderFns } from "./ComImg.vue?vue&type=template&id=9e2a1486&scoped=true&"
import script from "./ComImg.vue?vue&type=script&lang=js&"
export * from "./ComImg.vue?vue&type=script&lang=js&"
import style0 from "./ComImg.vue?vue&type=style&index=0&id=9e2a1486&prod&scoped=true&lang=css&"
import style1 from "./ComImg.vue?vue&type=style&index=1&id=9e2a1486&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e2a1486",
  null
  
)

export default component.exports